/* import __COLOCATED_TEMPLATE__ from './paid.hbs'; */
import Component from '@glimmer/component';
import styles from './paid_or_expired.module.scss';

export default class SitePaymentLinkPaid extends Component {
  styles = styles;
}
